






































































import Vue from 'vue';

import { Job } from '@/core/entity';

import { listJobQL } from './graphql';

import JobView from "@/vue/components/JobView/index.vue";

export default Vue.extend({
  components: {
    'view-job': JobView,
  },

  apollo: {
    jobs: {
      query: listJobQL,
      fetchPolicy: 'network-only',
    },
  },

  data() {
    const jobId = this.$route.params.job_id;
    return {
      isDrawerVisible: jobId ? true : false,
      jobs: [] as Job[],
    };
  },

  computed: {
    jobId(): string {
      return this.$route.params.job_id;
    },
  },

  watch: {
    jobId(newVal: string | null) {
      this.isDrawerVisible = !!newVal;
    },
  },

  methods: {
    hideDrawer() {
      this.isDrawerVisible = false;
      if (this.jobId) {
        this.$router.back();
      }
    },

    showDrawer() {
      this.isDrawerVisible = true;
    },
  },
});
